import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-2xl font-heading text-primary-400">
              木瓜影视
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              高清电视剧全集免费在线观看，最新热播剧不缓冲无广告极速播放。海量电视剧资源每日更新，满足追剧需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors">电视剧大全</Link>
              </li>
              <li>
                <Link to="/category/costume" className="text-sm text-background-400 hover:text-primary-400 transition-colors">古装剧</Link>
              </li>
              <li>
                <Link to="/category/urban" className="text-sm text-background-400 hover:text-primary-400 transition-colors">都市剧</Link>
              </li>
              <li>
                <Link to="/category/suspense" className="text-sm text-background-400 hover:text-primary-400 transition-colors">悬疑剧</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/romance" className="text-sm text-background-400 hover:text-primary-400 transition-colors">爱情剧</Link>
              </li>
              <li>
                <Link to="/category/scifi" className="text-sm text-background-400 hover:text-primary-400 transition-colors">科幻剧</Link>
              </li>
              <li>
                <Link to="/category/comedy" className="text-sm text-background-400 hover:text-primary-400 transition-colors">喜剧</Link>
              </li>
              <li>
                <Link to="/category/spy" className="text-sm text-background-400 hover:text-primary-400 transition-colors">谍战剧</Link>
              </li>
              <li>
                <Link to="/category/history" className="text-sm text-background-400 hover:text-primary-400 transition-colors">历史剧</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">品牌介绍</Link>
              </li>
              <li>
                <a href="mailto:service@muguays.com" className="text-sm text-background-400 hover:text-primary-400 transition-colors">联系我们</a>
              </li>
              <li>
                <span className="text-sm text-background-400">邮箱: service@muguays.com</span>
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm text-background-300"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm text-background-300"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm text-background-300"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 木瓜影视 muguays.com — 高清电视剧免费在线观看平台
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}